<template>
  <div class="printManage column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width180">
          <el-input placeholder="设备名称" style="width: 100%;" clearable v-model="deviceName"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="设备编号" style="width: 100%;" clearable v-model="deviceNo"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-select placeholder="品牌" style="width: 100%;" filterable clearable v-model="brand">
            <el-option v-for="item in brandArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-select placeholder="型号" style="width: 100%;" filterable clearable v-model="model">
            <el-option v-for="item in modelArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="启用状态" style="width: 100%;" filterable clearable v-model="enableStatus">
            <el-option v-for="item in enableStatusArray" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="row-me row-center margin-top20" v-if="canOperate">
        <div class="btn-blue width130 btn-height40" @click="clickAdd">新增设备</div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="name" label="设备名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sn" label="设备编号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="brandName" label="品牌" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="modelSn" label="型号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="enableStatus" label="启用状态" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.enableStatus === 1 ? '正常' : scope.row.enableStatus === 2 ? '停用' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center" width="280" v-if="canOperate">
            <template #default="scope">
              <div class="row-me center-all">
                <div class="blue-text margin-left30" v-if="scope.row.enableStatus===2" @click="clickChange(scope.row)">
                  启用
                </div>
                <div class="blue-text margin-left30" v-if="scope.row.enableStatus===1" @click="clickChange(scope.row)">
                  停用
                </div>
                <div class="blue-text margin-left30" @click="clickDelete(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                       layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="新增设备" v-model="visible" width="600px" top="10vh" :destroy-on-close="true">
      <div class="row-me row-center">
        <div class="left-div"><span class="red-star">*</span>设备名称：</div>
        <div class="flex1">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.name"
                    maxlength="100"></el-input>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>设备编号：</div>
        <div class="flex1">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.sn"
                    maxlength="100"></el-input>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>品牌：</div>
        <div class="flex1">
          <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.brandName">
            <el-option v-for="item in brandArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>型号：</div>
        <div class="flex1">
          <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.modelSn">
            <el-option v-for="item in modelArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>启用状态：</div>
        <div class="flex1">
          <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.enableStatus">
            <el-option v-for="item in enableStatusArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me margin-top20">
        <div class="left-div">备注：</div>
        <div class="flex1">
          <el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable
                    v-model="detailItem.remark" maxlength="500" show-word-limit autosize></el-input>
        </div>
      </div>
      <div class="row-me row-center flex-end1 margin-top80">
        <div class="btn-blank width110 btn-height40" @click="visible=false">取消</div>
        <div class="btn-blue width110 btn-height40 margin-left20" @click="clickSave">保存</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      deviceName: '',
      deviceNo: '',
      brand: '',
      brandArray: [],
      model: '',
      modelArray: [],
      enableStatus: '',
      enableStatusArray: [{id: 1, name: '正常'}, {id: 2, name: '停用'}],
      tableData: [],
      pageNo: 1,
      total: 0,
      visible: false,
      detailItem: {},
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getDict()
    this.clickSearch()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //搜索
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.deviceName = ''
      this.deviceNo = ''
      this.brand = ''
      this.model = ''
      this.enableStatus = ''
      this.clickSearch()
    },
    clickAdd() {
      this.detailItem = {
        type: 1,
        enableStatus: 1,
      }
      this.visible = true
    },
    //启用停用
    clickChange(item) {
      this.$postFormRequest('/admin/systemConfig/printerEnableStatus', {
        id: item.id,
        enableStatus: item.enableStatus === 1 ? 2 : 1,
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/systemConfig/printerDelete', {
          id: item.id,
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //保存
    clickSave() {
      if (this.$method.isEmpty(this.detailItem.name)) {
        this.$message.error('请输入设备名称')
        return
      }
      if (this.$method.isEmpty(this.detailItem.sn)) {
        this.$message.error('请输入设备编号')
        return
      }
      if (this.$method.isEmpty(this.detailItem.brandName)) {
        this.$message.error('请选择设备品牌')
        return
      }
      if (this.$method.isEmpty(this.detailItem.modelSn)) {
        this.$message.error('请选择设备型号')
        return
      }
      if (this.$method.isEmpty(this.detailItem.enableStatus)) {
        this.$message.error('请选择启用状态')
        return
      }
      this.$postRequest('/admin/systemConfig/printerUpdate', this.detailItem).then((res) => {
        if (res) {
          this.visible = false
          this.clickSearch()
          this.$message.success(res.message)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getData() {
      this.$postFormRequest('/admin/systemConfig/printerPage', {
        name: this.deviceName,
        sn: this.deviceNo,
        brandName: this.brand,
        modelSn: this.model,
        enableStatus: this.enableStatus,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取下拉数据
    getDict() {
      this.$getRequest('/admin/systemConfig/getDict', {}).then((res) => {
        if (res) {
          this.brandArray = res.data.dayinjipinpaiList
          this.modelArray = res.data.dayinjixinghaoList
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.printManage {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .left-div {
    width: 110px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
